import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface MappingListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name: string;
}

const defaultFilters: MappingListingFilters = {
    page: 1,
    pageSize: 50,
    name: "",
    sortBy: "languageName",
    sortOrder: "asc"
};

export const useMappingListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<MappingListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<MappingListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [filters]);

    const setSort = (sort: ListTableSort): void => {
        setFilters((prevFilters: MappingListingFilters) => ({
            ...prevFilters,
            page: 1,
            sortBy: sort.by,
            sortOrder: sort.order
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: MappingListingFilters): MappingListingFilters => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters(
            (prevFilters: MappingListingFilters): MappingListingFilters => ({
                ...prevFilters,
                pageSize,
                page: 1
            })
        );
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: MappingListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setSort,
        setPage,
        setPageSize,
        setName,
        clearFilters
    };
};
